const requireModule = require.context('./modules', true, /menu\.js$/)

const menu = []

const sections = {
  store: {
    header: 'Store Management',
    items: []
  }
}

requireModule.keys().forEach(componentFilePath => {
  const nav = requireModule(componentFilePath).default
  if (nav) {
    menu.push(...nav)
  }
})

menu.forEach(item => {
  if (sections[item.section]) {
    sections[item.section].items.push(item)
  }
})

for (const i in sections) {
  sections[i].items.sort(function (a, b) {
    const ao = a.order || 0
    const bo = b.order || 0
    return bo - ao
  })
}

export default sections
